var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("article", [
    _c(
      "div",
      { class: ["toasts", { hide: _vm.hasFlaggedItems }] },
      _vm._l(_vm.items, function(item) {
        return _c(
          "div",
          { key: item.id, staticClass: "toast", attrs: { id: item.id } },
          [
            _c("div", { staticClass: "toast-body" }, [
              _c("i", { staticClass: "icon icon-check" }),
              _vm._v(" " + _vm._s(_vm.$t("" + item.body)) + " ")
            ])
          ]
        )
      }),
      0
    ),
    _vm._v(
      " " + _vm._s(this.getToast.isOpen === true ? this.click() : "") + " "
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }